module.exports = __webpack_public_path__ + "media/images/icons/history-70077dda06374f9fd2ebaece28014329.svg";